import { useContext } from "react";
import { UserContext } from "../../../engine/context/User.context";
import { userHasLevel } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import { customers, onlyCustomers } from "../../../engine/customerConfig";
import { whiteListeSuperAdmin } from "../../../engine/hooks/hooks.helpers";

/** SOS Ticino / DERMAN (admin / permanence) or platform super users — for Solede ERP UI. */
export function useCanSeeSoledeErpSync() {
  const { user } = useContext(UserContext);
  const isSuperUser =
    user &&
    (whiteListeSuperAdmin.includes(user.email) ||
      (Array.isArray(user.subRoles) && user.subRoles.includes("superAdmin")));
  const isSosticinoOpsUser =
    onlyCustomers([customers.sosticino]) &&
    userHasLevel({
      only: {
        [roles.admin]: "r",
        [roles.permanance]: "r",
      },
    });
  return Boolean(isSuperUser || isSosticinoOpsUser);
}
